import { render, staticRenderFns } from "./NotFoundComponent.vue?vue&type=template&id=7e72abb0"
import script from "./NotFoundComponent.vue?vue&type=script&lang=ts"
export * from "./NotFoundComponent.vue?vue&type=script&lang=ts"
import style0 from "./NotFoundComponent.vue?vue&type=style&index=0&id=7e72abb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports